
import { SleepFormData } from "../../SleepFormContext";
import { useToast } from "@/hooks/use-toast";

export function logSubmissionData(values: SleepFormData) {
  console.log(' SLEEP SESSION SUBMIT - Form values debug:', { 
    childId: values.childId,
    caregiverId: values.caregiverId,
    formStartTime: values.start_time,
    formEndTime: values.end_time
  });

  console.log(' Raw form dates:', {
    start_time: values.start_time ? values.start_time.toString() : 'undefined',
    end_time: values.end_time ? values.end_time.toString() : 'undefined',
  });

  // Validate dates before using them
  const startDate = values.start_time instanceof Date ? values.start_time : new Date(values.start_time);
  const endDate = values.end_time ? (values.end_time instanceof Date ? values.end_time : new Date(values.end_time)) : null;

  // Only log if dates are valid
  if (!isNaN(startDate.getTime())) {
    console.log(' Start date ISO:', startDate.toISOString());
  } else {
    console.error(' Invalid start date:', values.start_time);
  }
  
  if (endDate && !isNaN(endDate.getTime())) {
    console.log(' End date ISO:', endDate.toISOString());
  } else if (values.end_time) {
    console.error(' Invalid end date:', values.end_time);
  }
}

export function validateSleepFormData(values: SleepFormData, toast: ReturnType<typeof useToast>['toast']) {
  if (!values.childId) {
    toast({
      variant: "destructive",
      title: "Error",
      description: "Please select a child first"
    });
    return false;
  }

  if (!values.caregiverId) {
    toast({
      variant: "destructive",
      title: "Error",
      description: "Caregiver data not found"
    });
    return false;
  }

  return true;
}

export function logTimezoneDebugInfo(startDate: Date, endDate: Date | null) {
  console.log(' TIMEZONE DEBUG - Sleep Session Data:');
  
  // Validate start date
  if (startDate && !isNaN(startDate.getTime())) {
    console.log('Start date (UTC from form):', startDate.toString());
    console.log('Start date ISO:', startDate.toISOString());
  } else {
    console.error(' Invalid start date:', startDate);
  }
  
  // Validate end date (optional)
  if (endDate && !isNaN(endDate.getTime())) {
    console.log('End date (UTC from form):', endDate.toString());
    console.log('End date ISO:', endDate.toISOString());
  } else if (endDate) {
    console.error(' Invalid end date:', endDate);
  }
  
  console.log('Local timezone offset:', new Date().getTimezoneOffset());
  console.log(' END TIMEZONE DEBUG');
}
